import React from 'react';
import { Snackbar } from '@mui/material';

const SnackBarMessage = ({
  isSnackbarOpen,
  snackBarMessage,
  snackBarDuration,
  snackBarPosition,
  setIsSnackbarOpen,
}) => {
  const handleClose = () => setIsSnackbarOpen(false);

  return (
    <Snackbar
      open={isSnackbarOpen}
      autoHideDuration={snackBarDuration * 1000}
      message={snackBarMessage}
      onClose={handleClose}
      anchorOrigin={snackBarPosition}
    />
  );
};

export default SnackBarMessage;
